﻿﻿export interface IToken {
    access_token: string;
    expires: string;
    expires_in: string;
    refresh_token: string;
    refresh_expires: string;
}
